/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import ClassroomRouteLinkItem from './ClassroomRouteLinkItem';
import ResourcesIcon from 'icons/ResourcesIcon';
import {useUserContext} from 'app/UserContext';
import {useMidasJsonApi} from 'app/hooks';

const messages = defineMessages({
  title: {id: 'navigation.resources'},
});

const ResourcesItem = () => {
  const [{classroom}] = useUserContext();

  const [response] = useMidasJsonApi({
    url: `/midas/rest/pd-section/${classroom.sectionID}?fields=id`,
    expectedStatus: [200, 404],
  });

  // If a PD section does exist, don't show the resources link (this item)
  if (response.json?.section) {
    return null;
  }

  return (
    <ClassroomRouteLinkItem
      iconBefore={ResourcesIcon}
      route="midas/classroom/resources"
      title={messages.title}
    />
  );
};

export default ResourcesItem;
